import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutsBaseComponent } from './base/base.component';
import { LayoutMainComponent } from './main/main.component';
import { LayoutsAsideMenuComponent } from './asides/aside-menu.component';
import { LayoutsAsidePrimaryComponent } from './asides/aside-primary.component';
import { LayoutsAsideSecondaryComponent } from './asides/aside-secondary.component';
import { LayoutMainPanelComponent } from './main/main-panel.component';
import { LayoutsHeaderComponent } from './header/header.component';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [
        LayoutsBaseComponent,
        LayoutsAsideMenuComponent,
        LayoutMainComponent,
        LayoutsAsidePrimaryComponent,
        LayoutsAsideSecondaryComponent,
        LayoutMainPanelComponent,
        LayoutsHeaderComponent,
    ],
    exports: [
        LayoutsBaseComponent,
        LayoutsAsideMenuComponent,
        LayoutMainComponent,
        LayoutsAsidePrimaryComponent,
        LayoutsAsideSecondaryComponent,
        LayoutMainPanelComponent,
        LayoutsHeaderComponent,
    ],
})
export class LayoutsModule {}
